import { has } from 'lodash'
import { isBaseOutput } from './base-output.model'

export enum AccountState {
  'unconfirmedAccount' = 2,
  'disabledAccount' = 3,
  'blacklistedAccount' = 4,
  'wrongCredentials' = 6,
  'blockedIp' = 7,
  'applicationError' = 11,
  'guidNotFound' = 16,
}

export interface ThinRegistrationBaseOutput {
  /* eslint-disable @typescript-eslint/naming-convention */
  AccountState: AccountState
  GuidAccount: string
  Email: string
  LockedTime: number
  Password: string
  PhoneNumber: string
  PhonePrefix: string
  RemainingPasswordAttempts: number
  /* eslint-enable @typescript-eslint/naming-convention */
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isThinRegistrationBaseOutput = (obj: any): obj is ThinRegistrationBaseOutput => {
  const accountState = 'AccountState'
  const email = 'Email'
  const phoneNumber = 'PhoneNumber'
  const phonePrefix = 'PhonePrefix'

  return (
    isBaseOutput(obj) && has(obj, accountState) && has(obj, email) && has(obj, phoneNumber) && has(obj, phonePrefix)
  )
}
